import Video from '@/app/components/Video'
import { ARTICLE_BLOCK_SPACING } from '@/app/utils/articleBlock'
import { cn } from '@/app/utils/style'
import type { Video as VideoType } from '@/sanity.types'

interface PostVideoProps {
  video: VideoType
  className?: string
}

/** Article video: rounded, centred, and narrower when the footage is portrait. */
export const PostVideo = ({ video, className }: PostVideoProps) => {
  const isPortrait = (video.vimeo?.height ?? 0) > (video.vimeo?.width ?? 0)

  return (
    <div className={cn(ARTICLE_BLOCK_SPACING, isPortrait && 'mx-auto w-2/3 md:w-1/2', className)}>
      <Video video={video} className="overflow-hidden rounded-sm lg:rounded-md" />
    </div>
  )
}
